import { render, staticRenderFns } from "./admin-title.vue?vue&type=template&id=7f68e71f&scoped=true&functional=true"
import script from "./admin-title.vue?vue&type=script&lang=js"
export * from "./admin-title.vue?vue&type=script&lang=js"
import style0 from "./admin-title.vue?vue&type=style&index=0&id=7f68e71f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7f68e71f",
  null
  
)

export default component.exports